import React from "react";
import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/joy";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import { DIGEST_TEMPLATES, DigestTemplate } from "../digestTemplates";

interface DigestTemplatePickerProps {
  onSelect: (template: DigestTemplate) => void;
}

/** Ready-made digests; picking one opens the New Digest form prefilled. */
const DigestTemplatePicker: React.FC<DigestTemplatePickerProps> = ({
  onSelect,
}) => (
  <Stack spacing={1.5}>
    <Box>
      <Typography level="title-md" startDecorator={<AutoAwesomeIcon />}>
        Start from a template
      </Typography>
      <Typography level="body-sm" color="neutral">
        Pick one to get a weekly digest without writing your own prompt. You can
        adjust everything before saving.
      </Typography>
    </Box>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(auto-fill, minmax(260px, 1fr))",
        },
        gap: 2,
      }}
    >
      {DIGEST_TEMPLATES.map((template) => (
        <Card
          key={template.id}
          component="button"
          type="button"
          variant="outlined"
          onClick={() => onSelect(template)}
          aria-label={`Use the ${template.name} template`}
          sx={{
            textAlign: "left",
            cursor: "pointer",
            font: "inherit",
            bgcolor: "background.surface",
            transition: "all 0.2s ease",
            "&:hover": { boxShadow: "sm", borderColor: "primary.300" },
            "&:focus-visible": {
              outline: "2px solid",
              outlineColor: "primary.500",
              outlineOffset: 2,
            },
          }}
        >
          <CardContent>
            <Stack spacing={1} sx={{ height: "100%" }}>
              <Typography level="title-md">{template.name}</Typography>
              <Typography level="body-sm" color="neutral" sx={{ flex: 1 }}>
                {template.description}
              </Typography>
              <Box>
                <Chip size="sm" variant="soft" color="success">
                  Weekly, by email
                </Chip>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Box>
  </Stack>
);

export default DigestTemplatePicker;
